exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".von-toggle[_v-5623c656]{height:50px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=_v-5623c656&scoped=true!./~/sass-loader!./~/vue-loader/lib/selector.js?type=style&index=0!./src/components/toggle/index.vue
// module id = 186
// module chunks = 0